const Config = require('../state/config');

const getProxyRedirectUrl = (redirectUrl) => {
  return `${Config.getProxyUrl()}/v1/http?redirectUrl=${encodeURI(redirectUrl)}`;
};

module.exports = getProxyRedirectUrl;